/**
 * use-drilldown.ts — Truy vết một chỉ số trên màn Tổng quan.
 *
 * Gửi lên ĐÚNG bộ lọc mà thẻ đang dùng (kỳ + kênh + tài khoản), nên bảng chi
 * tiết mở ra luôn là những dòng đã cộng thành đúng con số người dùng vừa bấm.
 */
import { useApiQuery } from '@/hooks/use-api'
import { modeToParams, type ChatReportMode, type ChatReportScope } from '@/hooks/use-chat-report'

/** Khớp danh sách CHI_SO bên backend. */
export type ChiSoTruyVet =
  | 'conversations' | 'messages' | 'unrepliedConversations' | 'unreadConversations' | 'unreadMessages'
  | 'appointments' | 'newContacts' | 'totalContacts'
  | 'friends' | 'msgIn' | 'msgPerFriend' | 'afterHours' | 'afterHoursPct'
  | 'chatters' | 'chattersPct' | 'afterHoursChatters' | 'afterHoursChattersPct' | 'aiConversations'
  | 'orders' | 'convRate' | 'revenue' | 'aiOrders' | 'aiPct'

export interface CotTruyVet {
  key: string
  nhan: string
  kieu?: 'text' | 'so' | 'ngay' | 'tien'
}

export interface KetQuaTruyVet {
  metric: ChiSoTruyVet
  tieuDe: string
  kyNhan: string
  theoKy: boolean
  nguon: { bang: string; dieuKien: string[] }
  congThuc?: { bieuThuc: string; thanhPhan: { nhan: string; giaTri: string }[] }
  ghiChu?: string
  cot: CotTruyVet[]
  dong: Record<string, unknown>[]
  tong: number
  cachTinhTong: 'dem' | 'cong'
  trang: number
  soDongMoiTrang: number
  soDong: number
}

export function useDrilldown(
  metric: ChiSoTruyVet | null,
  mode: ChatReportMode,
  scope: ChatReportScope | undefined,
  trang: number,
) {
  const params = { ...modeToParams(mode, scope), metric: metric ?? '', page: String(trang) }
  return useApiQuery<KetQuaTruyVet>(['dashboard-drilldown', params], '/dashboard/drilldown', params, {
    enabled: !!metric,
  })
}
